import { useEffect, useState } from "react";
import { Collapse } from "@mui/material";
import { MdKeyboardArrowDown } from "react-icons/md";
import {
  ButtonViewDetalher,
  ContainerCalendar,
  ContainerCardPeriodic,
  DivFlexBetween,
  DivRowFlex,
  InnerOccupacionalHealthContainer,
} from "./CardPeriodic.styled";

import {
  H2,
  Text,
  TextLink,
} from "../../components/UI/generalLayout/Layout.styled";
import { ReactComponent as CareLine } from "../../assets/imgs/careLine.svg";
import { ReactComponent as Calendar } from "../../assets/imgs/calendarIcon.svg";
import Colors from "../../constants/Colors";
import { useNavigate } from "react-router-dom";
import { Paths } from "../../enums/Paths";
import useResponsiveInfo from "../../hooks/useResponsiveInfo";
import CardPeriodicAtendimentoArea from "./CardPeriodicAtendimentoArea";
import CardPeriodicExamArea from "./CardPeriodicExamArea";
import { checkForeseeableDate } from "../../helpers/HelperFunctions";

interface ICardPeriodic {
  title: string;
  data?: any;
  isCareLine: boolean;
  isAppointment?: boolean;
}

const CardPeriodic = ({ title, data = {}, isCareLine, isAppointment = false }: ICardPeriodic) => {
  const [isOpen, setIsOpen] = useState(false);
  const [nextDate, setNextDate] = useState({ nome: '', outdated: false })
  const navigate = useNavigate();
  const { isMobile } = useResponsiveInfo();

  useEffect(() => {
    if (data.categorias && data.categorias.length > 0) {
      const sortedCategories = data.categorias.sort((a: any, b: any) =>
        a.dataPrevista < b.dataPrevista ? 1 : a.dataPrevista > b.dataPrevista ? -1 : 0
      )
      const object = checkForeseeableDate(sortedCategories[0].dataPrevista)
      setNextDate(object)
    }
  }, [data.categorias])

  const getNextExams = () => {
    let exams: string = '';
    if (data.exames && data.exames.length > 0) {
      data.exames.forEach((exame: any, index: number) => {
        exams += exame.nome 
        if((index +1) !== data.exames.length){
          exams += ', '
        }
      })
    }

    if (exams.length >= 29) {
      exams = exams.substring(0, 25) + '...'
    }
    return exams;
  }

  const onClickInnerSetAppointment = () => {
    navigate(Paths.Scheduling, { state: { consultType: 'Periodica' } });
  }

  return (
    <ContainerCardPeriodic>
      <DivFlexBetween>
        <DivRowFlex>
          <CareLine style={{ marginRight: 10, flexShrink: 0 }} />
          <div>
            <Text bold style={{ color: "#0F172A", fontSize: "15px" }}>{title}</Text>
            {isAppointment && (<Text style={{ marginTop: -12, marginBottom: -5, fontSize: 13, color: '#0A5190' }}>Ver mais detalhes</Text>)}
          </div>

        </DivRowFlex>
        <ContainerCalendar style={{ marginRight: isMobile ? 20 : 0 }} isOutdated={nextDate.outdated} isMobile={isMobile}>
          <Calendar stroke={nextDate.outdated? Colors.error : '#64748B'} />
          <Text
            color={nextDate.outdated? Colors.error : '#64748B'}
            bold
            style={{ fontSize: 14, marginLeft: 10 }}
          >
            {nextDate.nome}
          </Text>
        </ContainerCalendar>
        {!isMobile && (<div style={{ width: 250, overflowX: 'hidden' }}>
          <Text color="#0A5190">{getNextExams()}</Text>
        </div>)}

        {!isAppointment && (<ButtonViewDetalher
          onClick={() => {
            setIsOpen((prev) => !prev);
          }}
        >
          {!isMobile && (<TextLink
            style={{
              color: Colors.SPM500,
              fontSize: 14,
              fontWeight: 600,
              marginRight: 8,
            }}
          >
            VER DETALHES
          </TextLink>)}
          <MdKeyboardArrowDown 
            size={24} 
            style={{ 
              color: isOpen ? "#0A5190" : "#64748B",
              transition: "transform 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
              transform: isOpen ? "rotate(180deg)" : "rotate(0deg)"
            }} 
          />
        </ButtonViewDetalher>)}
      </DivFlexBetween>

      <Collapse in={isOpen} timeout={300}>
        <div style={{ marginTop: "16px", paddingTop: "12px", borderTop: "1px solid #F1F5F9" }}>
          <div>
            <H2 style={{ fontSize: "16px", color: "#0F172A", fontWeight: 700, marginBottom: "12px" }}>Atendimento</H2>
            <InnerOccupacionalHealthContainer>
              <div style={{ flexDirection: 'column', display: 'flex', width: '100%' }}>
                {data.categorias && data.categorias.map((c: any) => {
                  return (
                    <CardPeriodicAtendimentoArea key={c.id || c.nome} isCareLine={isCareLine} data={c} onClickInnerSetAppointment={onClickInnerSetAppointment} />
                  )
                })}
              </div>
            </InnerOccupacionalHealthContainer>
          </div>
          <div style={{ marginTop: "16px" }}>
            <H2 style={{ fontSize: "16px", color: "#0F172A", fontWeight: 700, marginBottom: "12px" }}>Exames</H2>
            <div style={{ flexDirection: 'row', display: 'flex' }}>
              <div style={{ width: '53%' }}>

              </div>
              {!isMobile && (<div style={{ width: '47%', display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                <Text bold style={{ color: "#64748B", fontSize: "13px" }}>Data da solicitação</Text>
                <Text bold style={{ color: "#64748B", fontSize: "13px" }}>Situação</Text>
              </div>)}
            </div>

            <InnerOccupacionalHealthContainer>
              <div style={{ flexDirection: "column", display: "flex", width: '100%' }}>
                {data.exames && data.exames.map((exame: any) => {
                  return (<CardPeriodicExamArea key={exame.id || exame.nome} exame={exame} />)
                })}
              </div>
            </InnerOccupacionalHealthContainer>
          </div>
        </div>
      </Collapse>
    </ContainerCardPeriodic>
  );
};

export default CardPeriodic;
